// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.histogram-picker-popup {
  width: 312px;
  background: rgb(var(--white));
  box-shadow: 0px 0px var(--shadow-blur-big) var(--shadow-gray);
  border-radius: var(--border-radius);
  -webkit-user-select: none;
          user-select: none;
}
.histogram-picker-popup__loading, .histogram-picker-popup__error {
  height: 186px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.histogram-picker-popup__error {
  padding: var(--spacing3);
  text-align: center;
}
.histogram-picker-popup__bottom {
  padding: var(--spacing3) 0;
  text-align: right;
}

.histogram-input-box {
  padding: var(--spacing2) var(--spacing1);
}
.histogram-input-box__input-wrapper {
  display: inline-block;
  width: 140px;
  vertical-align: middle;
  text-align: left;
}
.histogram-input-box__dash {
  display: inline-block;
  vertical-align: middle;
  margin: 0 var(--spacing0);
}
.histogram-input-box__input {
  display: inline-block;
  width: 100%;
  background: none;
  border: none;
  outline: none;
}

.histogram {
  position: relative;
  height: 98px;
  box-sizing: border-box;
  padding: 0 var(--spacing1) 0;
}
.histogram * {
  box-sizing: border-box;
}
.histogram__wrapper {
  position: relative;
  border-radius: var(--border-radius);
  border: 1px solid #ccc;
  height: 100%;
}
.histogram__wrapper-content {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 78px;
}
.histogram__wrapper-content-bar {
  display: inline-block;
  background: rgb(var(--base-60));
}
.histogram__wrapper-overlay {
  position: absolute;
  height: 100%;
  background: rgba(249, 249, 249, 0.8);
}
.histogram__wrapper-overlay-handle {
  position: absolute;
  top: 50%;
  width: 11px;
  height: 28px;
  background: #ffffff;
  box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.3);
  transform: translateY(-50%);
  cursor: grab;
}
.histogram__wrapper-overlay-handle--left {
  right: 0;
  border-right: none;
  border-radius: var(--border-radius) 0 0 var(--border-radius);
}
.histogram__wrapper-overlay-handle--right {
  left: 0;
  border-left: none;
  border-radius: 0 var(--border-radius) var(--border-radius) 0;
}
.histogram__wrapper-overlay-handle:after {
  display: block;
  content: "";
  width: 2px;
  height: 10px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: #ccc;
  border-radius: 2px;
}
.histogram--dragging .histogram__wrapper-overlay-handle {
  cursor: grabbing;
}
.histogram__wrapper-overlay--left {
  left: 0;
  border-right: 1px solid rgb(var(--base-90));
}
.histogram__wrapper-overlay--right {
  border-left: 1px solid rgb(var(--base-90));
  right: 0;
}
.histogram--dragging {
  cursor: grabbing;
}

.histogram-axis {
  padding: 0 var(--spacing1);
}
.histogram-axis__ticks {
  position: relative;
  height: 4px;
}
.histogram-axis__tick {
  display: inline-block;
  position: absolute;
  top: 0;
  height: 100%;
  width: 1px;
  background-color: #999;
}
.histogram-axis__values {
  position: relative;
  height: 16px;
}
.histogram-axis__value {
  display: inline-block;
  position: absolute;
  top: 0;
  left: 0;
  font-size: 12px;
  transform: translateX(-50%); /* centering trick */
  color: #999;
}`, "",{"version":3,"sources":["webpack://./libs/shared/ui-histogram-filter/src/lib/histogram-filter/histogram-picker-popup/histogram-picker-popup.component.scss"],"names":[],"mappings":"AAEA;EACI,YAAA;EACA,6BAAA;EACA,6DAAA;EACA,mCAAA;EACA,yBAAA;UAAA,iBAAA;AADJ;AAGI;EAEI,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAFR;AAKI;EACI,wBAAA;EACA,kBAAA;AAHR;AAMI;EACI,0BAAA;EACA,iBAAA;AAJR;;AAQA;EACI,wCAAA;AALJ;AAOI;EACI,qBAAA;EACA,YAAA;EACA,sBAAA;EACA,gBAAA;AALR;AAQI;EACI,qBAAA;EACA,sBAAA;EACA,yBAAA;AANR;AASI;EACI,qBAAA;EACA,WAAA;EACA,gBAAA;EACA,YAAA;EACA,aAAA;AAPR;;AAWA;EACI,kBAAA;EACA,YAAA;EACA,sBAAA;EACA,4BAAA;AARJ;AAUI;EACI,sBAAA;AARR;AAWI;EACI,kBAAA;EACA,mCAAA;EACA,sBAAA;EACA,YAAA;AATR;AAWQ;EACI,kBAAA;EACA,OAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;AATZ;AAWY;EACI,qBAAA;EACA,+BAAA;AAThB;AAaQ;EACI,kBAAA;EACA,YAAA;EACA,oCAAA;AAXZ;AAaY;EACI,kBAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,0CAAA;EACA,2BAAA;EACA,YAAA;AAXhB;AAagB;EACI,QAAA;EACA,kBAAA;EACA,4DAAA;AAXpB;AAcgB;EACI,OAAA;EACA,iBAAA;EACA,4DAAA;AAZpB;AAegB;EACI,cAAA;EACA,WAAA;EACA,UAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,gBAAA;EACA,kBAAA;AAbpB;AAgBgB;EACI,gBAAA;AAdpB;AAkBY;EACI,OAAA;EACA,2CAAA;AAhBhB;AAmBY;EACI,0CAAA;EACA,QAAA;AAjBhB;AAsBI;EACI,gBAAA;AApBR;;AAwBA;EACI,0BAAA;AArBJ;AAuBI;EACI,kBAAA;EACA,WAAA;AArBR;AAwBI;EACI,qBAAA;EACA,kBAAA;EACA,MAAA;EACA,YAAA;EACA,UAAA;EACA,sBAAA;AAtBR;AAyBI;EACI,kBAAA;EACA,YAAA;AAvBR;AA0BI;EACI,qBAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,eAAA;EACA,2BAAA,EAAA,oBAAA;EACA,WAAA;AAxBR","sourcesContent":["@use \"definitions\" as *;\n\n.histogram-picker-popup {\n    width: 312px;\n    background: lg-color(--white);\n    box-shadow: 0px 0px var(--shadow-blur-big) var(--shadow-gray);\n    border-radius: var(--border-radius);\n    user-select: none;\n\n    &__loading,\n    &__error {\n        height: 186px;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n    }\n\n    &__error {\n        padding: var(--spacing3);\n        text-align: center;\n    }\n\n    &__bottom {\n        padding: var(--spacing3) 0;\n        text-align: right;\n    }\n}\n\n.histogram-input-box {\n    padding: var(--spacing2) var(--spacing1);\n\n    &__input-wrapper {\n        display: inline-block;\n        width: 140px;\n        vertical-align: middle;\n        text-align: left;\n    }\n\n    &__dash {\n        display: inline-block;\n        vertical-align: middle;\n        margin: 0 var(--spacing0);\n    }\n\n    &__input {\n        display: inline-block;\n        width: 100%;\n        background: none;\n        border: none;\n        outline: none;\n    }\n}\n\n.histogram {\n    position: relative;\n    height: 98px;\n    box-sizing: border-box;\n    padding: 0 var(--spacing1) 0;\n\n    * {\n        box-sizing: border-box;\n    }\n\n    &__wrapper {\n        position: relative;\n        border-radius: var(--border-radius);\n        border: 1px solid #ccc;\n        height: 100%;\n\n        &-content {\n            position: absolute;\n            left: 0;\n            bottom: 0;\n            width: 100%;\n            height: 78px;\n\n            &-bar {\n                display: inline-block;\n                background: lg-color(--base-60);\n            }\n        }\n\n        &-overlay {\n            position: absolute;\n            height: 100%;\n            background: rgba(249, 249, 249, 0.8);\n\n            &-handle {\n                position: absolute;\n                top: 50%;\n                width: 11px;\n                height: 28px;\n                background: #ffffff;\n                box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.3);\n                transform: translateY(-50%);\n                cursor: grab;\n\n                &--left {\n                    right: 0;\n                    border-right: none;\n                    border-radius: var(--border-radius) 0 0 var(--border-radius);\n                }\n\n                &--right {\n                    left: 0;\n                    border-left: none;\n                    border-radius: 0 var(--border-radius) var(--border-radius) 0;\n                }\n\n                &:after {\n                    display: block;\n                    content: \"\";\n                    width: 2px;\n                    height: 10px;\n                    position: absolute;\n                    top: 50%;\n                    left: 50%;\n                    transform: translate(-50%, -50%);\n                    background: #ccc;\n                    border-radius: 2px;\n                }\n\n                .histogram--dragging & {\n                    cursor: grabbing;\n                }\n            }\n\n            &--left {\n                left: 0;\n                border-right: 1px solid lg-color(--base-90);\n            }\n\n            &--right {\n                border-left: 1px solid lg-color(--base-90);\n                right: 0;\n            }\n        }\n    }\n\n    &--dragging {\n        cursor: grabbing;\n    }\n}\n\n.histogram-axis {\n    padding: 0 var(--spacing1);\n\n    &__ticks {\n        position: relative;\n        height: 4px;\n    }\n\n    &__tick {\n        display: inline-block;\n        position: absolute;\n        top: 0;\n        height: 100%;\n        width: 1px;\n        background-color: #999;\n    }\n\n    &__values {\n        position: relative;\n        height: 16px;\n    }\n\n    &__value {\n        display: inline-block;\n        position: absolute;\n        top: 0;\n        left: 0;\n        font-size: 12px;\n        transform: translateX(-50%); /* centering trick */\n        color: #999;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
